
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import Q1Page from '../pages/q1/page';
import Q2Page from '../pages/q2/page';
import Q3Page from '../pages/q3/page';
import Q4Page from '../pages/q4/page';
import ConclusionPage from '../pages/conclusion/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/q1',
    element: <Q1Page />,
  },
  {
    path: '/q2',
    element: <Q2Page />,
  },
  {
    path: '/q3',
    element: <Q3Page />,
  },
  {
    path: '/q4',
    element: <Q4Page />,
  },
  {
    path: '/conclusion',
    element: <ConclusionPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
